// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__H3-zx","errors":"Errors_errors__1UQ37"};